import { ColDef } from 'ag-grid-community';

export class GridColDefsSeguridadEmpresas{

  public columnDefs: ColDef[] = [
    { headerName: "Nombre de la empresa", field: "nombreEmpresa", sortable: true, filter: true, headerClass: "header", wrapText: true, autoHeight: true, checkboxSelection: true, width: 500 }
  ]

}
